'use client';

import { useRouter } from 'next/navigation';

export default function GameButtons() {
  const router = useRouter();

  const handleStartGame = () => {
    router.push('/game');
  };
  const handleStartRandomGame = () => {
    router.push('/randomgame');
  };
  const handleSubmitLocation = () => {
    router.push('/submit');
  };

  return (
    <div className="flex flex-col sm:flex-row flex-nowrap gap-4 sm:overflow-x-auto">
      <button
        className="shrink-0 flex w-full sm:max-w-xs flex-col gap-4 rounded-xl bg-white/10 p-4 text-white hover:bg-white/20"
        onClick={handleStartGame}
      >
        <h3 className="text-2xl font-bold">Start Game →</h3>
        <div className="text-lg">
          Guess locations across the world of RuneScape. Location pack updated weekly.
        </div>
      </button>
      <button
        className="shrink-0 flex w-full sm:max-w-xs flex-col gap-4 rounded-xl bg-white/10 p-4 text-white hover:bg-white/20"
        onClick={handleStartRandomGame}
      >
        <h3 className="text-2xl font-bold">Start Random Game →</h3>
        <div className="text-lg">
          Guess 5 random locations from previous location packs.
        </div>
      </button>
      <button
        className="shrink-0 flex w-full sm:max-w-xs flex-col gap-4 rounded-xl bg-white/10 p-4 text-white hover:bg-white/20"
        onClick={handleSubmitLocation}
      >
        <h3 className="text-2xl font-bold">Submit a Location →</h3>
        <div className="text-lg">
          Help grow the game by submitting new locations for others to guess!
        </div>
      </button>
      {/* <button
        className="flex max-w-xs flex-col gap-4 rounded-xl bg-white/10 p-4 text-white hover:bg-white/20"
        onClick={handleHighScores}
      >
        <h3 className="text-2xl font-bold">High Scores →</h3>
        <div className="text-lg">
          View the leaderboard and compete with other players for the highest score.
        </div>
      </button> */}
    </div>
  );
}